import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import { useMemo } from 'react';
import { useToken } from '@rexlabs/styling';
import { merge } from 'lodash';
export function useConfig(_ref) {
  var _context, _context2;

  var target = _ref.target,
      configs = _ref.configs,
      getItemRef = _ref.getItemRef;
  var token = useToken();
  var config = useMemo(function () {
    return target && token(target) || _reduceInstanceProperty(configs).call(configs, function (all, config) {
      return merge(all, typeof config === 'string' ? token("transition.enterLeave.".concat(config), {}) : config);
    }, {});
  }, [target, configs, token]);

  _forEachInstanceProperty(_context = ['from', 'initial']).call(_context, function (stage) {
    if (typeof config[stage] === 'function') {
      var fn = config[stage];

      config[stage] = function (item) {
        return fn === null || fn === void 0 ? void 0 : fn(item, getItemRef === null || getItemRef === void 0 ? void 0 : getItemRef(item));
      };
    }
  }); // insert item refs if they are available


  _forEachInstanceProperty(_context2 = ['enter', 'update', 'leave']).call(_context2, function (stage) {
    if (typeof config[stage] === 'function') {
      var fn = config[stage];

      config[stage] = function (item) {
        return function (next) {
          var _fn;

          return fn === null || fn === void 0 ? void 0 : (_fn = fn(item)) === null || _fn === void 0 ? void 0 : _fn(next, getItemRef === null || getItemRef === void 0 ? void 0 : getItemRef(item));
        };
      };
    }
  });

  return config;
}